import http from '@/utils/http';

export default {
    save: data => {
        return http({url:'/api/admin/v1/manage/save',data,tip:true,loading:true}).then(r => r);
    },
    delete: data => {
        return http({url:'/api/admin/v1/manage/delete',data,tip:true,loading:true}).then(r => r);
    },
    list: data => {
        return http({url:'/api/admin/v1/manage/list',data}).then(r => r);
    },
    listAll: data => {
        return http({url:'/api/admin/v1/manage/listAll',data}).then(r => r);
    },
}
